/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
import React, { useEffect, Suspense, useState } from "react";
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import ErrorBoundary from "./errorBoundary/ErrorBoundary";
import { configureAmplify } from "../src/views/Auth/auth";
import MainLayout from "./views/MainLayout";
import { routeList } from "../src/config/routes";
import { commonRoutes } from "../src/config/commonRoutes";
import { globalPath } from "./config/globalPaths";
import "antd/dist/antd.css";
import "./App.scss";
import { APIs, getPremiseId } from "./utils/worker";
import { message, Spin } from "antd";
import constants from "./constants/constants";
import { maintenanceConfig } from "./config/maintenance";
import Smcs_Loader from "./assests/images/loader-new.gif";
import { NetworkStatusProvider } from "./contexts/NetworkStatusContext";
const PageNotFound = React.lazy(() => import("./views/404"));
import { useLock } from "./store/LockContext";

// Fix for OOM: Move Proxy logic outside component
(() => {
  const EXCLUDE_KEYS = [
    "allPincodes",
    "showNotice",
    "content",
    "showRetail",
    "kycCompleted",
    "printerSettings",
    // Authentication keys - keep in localStorage
    "userinfo",
    "loggedOutTime",
    "userName",
    "userId",
    "selectedCompany",
    "isEnableCP",
    "customerId",
  ];

  const storageProxy = new Proxy(window.localStorage, {
    get(target, prop) {
      if (prop === "setItem") {
        return function (key, value) {
          if (EXCLUDE_KEYS.includes(key)) {
            target.setItem(key, value);
          } else {
            sessionStorage.setItem(key, value);
          }
        };
      }

      if (prop === "getItem") {
        return function (key) {
          if (EXCLUDE_KEYS.includes(key)) {
            return target.getItem(key);
          }
          return sessionStorage.getItem(key);
        };
      }

      if (prop === "removeItem") {
        return function (key) {
          if (EXCLUDE_KEYS.includes(key)) {
            target.removeItem(key);
          } else {
            sessionStorage.removeItem(key);
          }
        };
      }

      if (prop === "clear") {
        return function () {
          target.clear();
          sessionStorage.clear();
        };
      }

      return target[prop];
    },
  });

  try {
    Object.defineProperty(window, "localStorage", {
      value: storageProxy,
      configurable: true,
      enumerable: true,
    });
  } catch (e) {
    console.error("Failed to patch localStorage", e);
  }
})();

const App = () => {
  const [roles, setRoles] = useState();
  const currentEnv = process.env.REACT_APP_ENV;
  const store = sessionStorage;

  const [userInfo, setUserInfo] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    configureAmplify(true);
    //getsessionStorageSize("scannedAwbs");
  }, []);
  function getsessionStorageSize(key) {
    const value = store.getItem(key);
    if (value) {
      const size = key.length + value.length;
      console.log(`Size of "${key}": ${(size / 1024).toFixed(2)} KB`);
    }
  }

  const { fetchLockStatus } = useLock();

  useEffect(() => {
    const userinfo = JSON.parse(localStorage.getItem("userinfo"));
    console.log("userinfo", userinfo);
    if (userinfo?.cpId && userinfo?.cpId != "999") {
      fetchLockStatus(userinfo?.cpId);
      const callApi = () => fetchLockStatus(userinfo?.cpId);

      callApi();
      const interval = setInterval(callApi, 60000);

      return () => clearInterval(interval);
    }
  }, []);

  // function getsessionStorageSize() {
  //   let totalSize = 0;

  //   for (let key in sessionStorage) {
  //     console.log(key);
  //     if (sessionStorage.hasOwnProperty(key)) {
  //       const value = sessionStorage.getItem(key);
  //       totalSize += key.length + (value ? value.length : 0); // Add size of key and value
  //     }
  //   }

  //   console.log(`Total sessionStorage size: ${(totalSize / 1024).toFixed(2)} KB`);
  // }

  useEffect(() => {
    // Authentication data is now consistently in localStorage due to EXCLUDE_KEYS
    let userInfo = localStorage.getItem("loggedOutTime");
    let getRols = JSON.parse(localStorage.getItem("userinfo") || "null");
    const getRole = getRols?.roles[0]?.replace(/.*_/, "");

    setUserInfo(userInfo ? JSON.parse(userInfo) : null);
    setRoles(getRols);
    setIsInitialized(true);
    // if (
    //   !globalPath.includes(window.location.pathname) &&
    //   getRole === "HUBADMIN"
    // ) {
    //   getTodaysData();
    // }
  }, []);

  useEffect(() => {
    let getRols = JSON.parse(store.getItem("userinfo"));
    const getRole = getRols?.roles[0];
    const selectedCompany = JSON.parse(store.getItem("selectedCompany"));
    const isEnableCP = JSON.parse(localStorage.getItem("isEnableCP"));

    if (currentEnv === "qa" && isEnableCP) {
      if (constants?.ROLES?.CP_ADMIN?.includes(getRole) && !selectedCompany) {
        message.error("Please go back and select company");

        setInterval(() => {
          let showNotice = store.getItem("showNotice");
          store.clear();
          window.location.assign("/");
          document.cookie = "userToken=";
          store.clear();
          store.setItem("showNotice", showNotice);
        }, 3000);
      }
    }

    if (
      constants?.ROLES?.CP_ADMIN?.includes(getRole) &&
      !selectedCompany &&
      currentEnv === "prod"
    ) {
      message.error("Please go back and select company");

      setInterval(() => {
        let showNotice = store.getItem("showNotice");
        store.clear();
        window.location.assign("/");
        document.cookie = "userToken=";
        store.clear();
        store.setItem("showNotice", showNotice);
      }, 3000);
    }
  }, []);

  useEffect(() => {
    let sessionInterval;

    // Only start session monitoring after initialization and if user is supposed to be authenticated
    if (isInitialized && !globalPath.includes(window.location.pathname)) {
      // Authentication data is now consistently in localStorage due to EXCLUDE_KEYS
      const userName = JSON.parse(localStorage.getItem("userName") || "null");
      const userInfo = JSON.parse(
        localStorage.getItem("loggedOutTime") || "null",
      );
      const userRoles = JSON.parse(localStorage.getItem("userinfo") || "null");

      // If we have no authentication data at all, redirect to login
      if (!userName || !userInfo || !userRoles) {
        window.location.assign("/");
        return;
      }

      // Check if session is still valid
      const currentTime = new Date().getTime();
      if (currentTime >= userInfo) {
        let showNotice = localStorage.getItem("showNotice");
        localStorage.clear();
        sessionStorage.clear();
        window.location.assign("/");
        document.cookie = "userToken=";
        localStorage.setItem("showNotice", showNotice);
        return;
      }

      sessionInterval = sessionOut();
    }

    // Cleanup interval on unmount or when dependencies change
    return () => {
      if (sessionInterval) {
        clearInterval(sessionInterval);
      }
    };
  }, [isInitialized]);

  const sessionOut = () => {
    const interval = setInterval(() => {
      const date = new Date();
      let userName = JSON.parse(localStorage.getItem("userName") || "null");
      let currentUserInfo = JSON.parse(
        localStorage.getItem("loggedOutTime") || "null",
      );

      if (
        maintenanceConfig.isActive &&
        !maintenanceConfig.testUsers.includes(
          JSON.parse(localStorage.getItem("userinfo") || "{}")?.spId,
        )
      ) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.assign("/");
        document.cookie = "userToken=";
      }

      if (!currentUserInfo || !userName || date.getTime() >= currentUserInfo) {
        let showNotice = localStorage.getItem("showNotice");
        localStorage.clear();
        sessionStorage.clear();
        window.location.assign("/");
        document.cookie = "userToken=";
        localStorage.setItem("showNotice", showNotice);
      }
    }, 1000);

    // Return cleanup function
    return interval;
  };

  // const getTodaysData = async () => {
  //   const a = premiseId.split("Bearer")[1];
  //   eventSource = new EventSource(
  //     `${baseURL}/hubops-report-service/v1/dashboard/${+a}`
  //   );

  //   eventSource.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     if (data) {
  //       // const array = dataConvertTOArray(data);
  //       sessionStorage.setItem("myValue", JSON.stringify(data));
  //     }
  //   };
  // };

  const dynamicRoutes = () => {
    let temp = [];
    routeList.map((item, index) => {
      item.role.some((rt) => {
        if (roles && roles?.roles?.includes(rt)) {
          temp.push(
            <Route
              exact
              key={`route_${index}`}
              path={item.route}
              element={<item.component />}
            />,
          );
        }
      });
    });

    return temp;
  };

  const globalRoutes = () => {
    let temp = [];
    commonRoutes.map((item, index) => {
      temp.push(
        <Route
          exact
          key={`route_${index}`}
          path={item.route}
          element={<item.component />}
        />,
      );
    });

    return temp;
  };

  // (() => {
  //   if (currentEnv == "qa") {

  //     if (window.localStorage) {
  //       Object.defineProperty(window, "localStorage", {
  //         value: sessionStorage,
  //         configurable: true,
  //         enumerable: true,
  //         writable: true,
  //       });
  //     }
  //   }
  // })();

  // const speed = useNetworkSpeed();
  // console.log(speed);

  return (
    <NetworkStatusProvider>
      <BrowserRouter basename="/">
        <MainLayout
          component={
            <Suspense fallback={null}>
              <ErrorBoundary>
                {!isInitialized ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100vh",
                    }}
                  >
                    <Spin
                      size="large"
                      spinning={true}
                      indicator={
                        <img
                          src={Smcs_Loader}
                          style={{ height: "100px", width: "100px" }}
                        />
                      }
                    />
                  </div>
                ) : (
                  <Routes>
                    <>
                      {globalRoutes()}
                      {dynamicRoutes()}
                      <Route path="*" element={<PageNotFound />} />
                    </>
                  </Routes>
                )}
              </ErrorBoundary>
            </Suspense>
          }
        />
      </BrowserRouter>
    </NetworkStatusProvider>
  );
};

export default App;
